import { render, staticRenderFns } from "./workShopEvaluation.vue?vue&type=template&id=5e91b086"
import script from "./workShopEvaluation.vue?vue&type=script&lang=js"
export * from "./workShopEvaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports